import { useEffect, useState } from "react";

/**
 * Returns true once the component has hydrated on the client.
 * Useful for wrapping UI that is sensitive to browser-extension DOM injections
 * (e.g. password-manager icons) during hydration.
 */
export function useHydrated() {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return hydrated;
}
